import React from "react";
import withProviders from "../../hooks/withProviders";
import AssetsManagement from "../../features/assetsmanagement";
import { AssetManagementDefaultFilters, FilterProvider} from "../../hooks/FilterContext";
import AssetsManagementProvider from "../../features/assetsmanagement/hooks/AssetsManagementContext";

const AssetsManagementPage = () => <AssetsManagement />

export default withProviders([FilterProvider, { defaultFilters: AssetManagementDefaultFilters }], AssetsManagementProvider)(AssetsManagementPage);